import { supabase } from "@/integrations/supabase/client";

type Signal = "copy" | "share" | "edit" | "regenerate";

export const trackSignal = async (
  decisionId: string | null,
  signal: Signal
): Promise<void> => {
  if (!decisionId) {
    console.log("No decision ID, skipping signal tracking:", signal);
    return;
  }

  try {
    const outcomeMap: Record<Signal, { outcome: string; reason: string }> = {
      copy: { outcome: "success", reason: "User copied the content" },
      share: { outcome: "success", reason: "User shared the content" },
      edit: { outcome: "partial", reason: "User edited the content before use" },
      regenerate: { outcome: "fail", reason: "User regenerated the content" },
    };

    const { outcome, reason } = outcomeMap[signal];

    await supabase.functions.invoke("track-outcome", {
      body: {
        decisionId,
        outcome,
        outcomeReason: reason,
        signal,
      },
    });

    console.log("Signal tracked:", signal, "for decision:", decisionId);
  } catch (error) {
    console.error("Failed to track signal:", error);
    // Don't throw - signal tracking should be silent
  }
};

export const useOutcomeTracking = () => {
  const trackCopy = (decisionId: string | null) => trackSignal(decisionId, "copy");
  const trackShare = (decisionId: string | null) => trackSignal(decisionId, "share");
  const trackEdit = (decisionId: string | null) => trackSignal(decisionId, "edit");
  const trackRegenerate = (decisionId: string | null) => trackSignal(decisionId, "regenerate");

  return {
    trackCopy,
    trackShare,
    trackEdit,
    trackRegenerate,
    trackSignal,
  };
};
